const initialState = {
  ContactMethods: "",
  TimeToContact: "",
  CustomerAvailabilityDate: ""
};

const customerAvailabilityReducer = (state = initialState, action: any) => {
  switch (action.type) {

    case "SET_CUSTOMER_AVAILABILITY":
      return {
        ...state,
        ...action.payload
      };

    case "RESET_CUSTOMER_AVAILABILITY":
      return initialState;

    default:
      return state;
  }
};

export default customerAvailabilityReducer;